// AUTO-GENERATED by `npm run codegen` - do not edit.
namespace $ {

export type demo_app_notesQueryVariables = Exact<{ [key: string]: never; }>;


export type demo_app_notesQuery = { __typename?: 'Query', notes: Array<(
    { __typename?: 'Note', id: string }
    & { ' \u0024fragmentRefs'?: { 'demo_note_card_noteFragment': demo_note_card_noteFragment } }
  )> };


/** Spreads fragments: $demo_note_card_note */
export function $demo_app_notes(opts?: { revalidate?: boolean }): demo_app_notesQuery {
	return $demo_graphql_request(`query demo_app_notes {
  notes {
    id
    ...demo_note_card_note
  }
}

fragment demo_note_card_note on Note {
  id
  title
  body
  likes
  author {
    name
  }
}`, undefined, opts) as demo_app_notesQuery
}

}
